/** Длина сообщения зрителям, как на бэкенде (EVENT_CANCEL_MESSAGE_MAX). */
export const EVENT_CANCEL_MESSAGE_MAX = 2000;

export type CancelEventFormError =
  | "confirmRequired"
  | "confirmMismatch"
  | "messageTooLong";

/** Ключи текстов ошибок (статические, см. i18n-правила partner-кабинета). */
export const CANCEL_EVENT_FORM_ERROR_KEYS: Record<
  CancelEventFormError,
  string
> = {
  confirmRequired: "products.eventCancel.errors.confirmRequired",
  confirmMismatch: "products.eventCancel.errors.confirmMismatch",
  messageTooLong: "products.eventCancel.errors.messageTooLong",
};

export interface CancelEventFormErrors {
  confirmTitle?: CancelEventFormError;
  message?: CancelEventFormError;
}

/**
 * Проверка окна отмены события: название введено и совпадает с названием
 * продукта (пробелы по краям прощаются, как на бэкенде), сообщение не
 * длиннее EVENT_CANCEL_MESSAGE_MAX. Ошибки это коды, текст по
 * CANCEL_EVENT_FORM_ERROR_KEYS.
 */
export function validateCancelEventForm(input: {
  confirmTitle: string;
  productTitle: string;
  message: string;
}): CancelEventFormErrors {
  const errors: CancelEventFormErrors = {};
  const confirmTitle = input.confirmTitle.trim();
  if (!confirmTitle) {
    errors.confirmTitle = "confirmRequired";
  } else if (confirmTitle !== input.productTitle.trim()) {
    errors.confirmTitle = "confirmMismatch";
  }
  if (input.message.trim().length > EVENT_CANCEL_MESSAGE_MAX) {
    errors.message = "messageTooLong";
  }
  return errors;
}
